import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants';

import { zodInvoiceDirectionSchema } from '../useQueryInvoices/validations';

/**
 * Validation schemas for the invoice party filter options API.
 */

const INVOICE_PARTY_ROLES = ['buyer', 'seller'] as const;

export const zodInvoicePartiesQueryParamsSchema = z.object({
  companyIds: z.array(z.uuid()).optional(),
  direction: zodInvoiceDirectionSchema,
  limit: z
    .number()
    .int()
    .min(1)
    .max(500)
    .prefault(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().int().min(0).prefault(0),
  partyRole: z.enum(INVOICE_PARTY_ROLES),
  searchString: z.string().trim().optional(),
});

export const zodInvoicePartySchema = z.object({
  id: z.uuid(),
  name: z.string(),
});

export const zodInvoicePartiesResponseSchema = z.object({
  data: z.array(zodInvoicePartySchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().int().nonnegative(),
  // The endpoint never computes a total; the contract pins this to null.
  totalCount: z.null(),
});
